import type {
  MultipleProductCard,
  SingularProductCard
} from "@shared/graphql.types";

export const isMultipleProductCard = (
  card?: SingularProductCard | MultipleProductCard
): card is MultipleProductCard => {
  return card?.type === "multivariate";
};
